import { createAction, props } from '@ngrx/store';
import { LoginPayload, LoginResponse } from '../../services/auth.service';
import {
  ServiceAppEntityServiceRead,
  SubpageAppEntitySubpageRead
} from '../../openapi';
import { TokenData, UISettings } from '../../services/ssession.service';
import { HttpErrorResponse } from '@angular/common/http';
import { ServiceListItem } from '../../services/service.common.model';

export const login = createAction('[App] login', props<{
  payload: LoginPayload,
  successFnc: () => void,
  failureFnc: () => void
}>());

export const loginSuccess = createAction('[App] login success', props<{ data: LoginResponse }>());

export const loginFailure = createAction('[App] login failure');

export const logout = createAction('[App] logout', props<{ successFnc: () => void }>());

export const loadServices = createAction('[App] load services');

export const loadServicesSuccess = createAction('[App] load services success', props<{
  services: Array<ServiceListItem>
}>());

export const loadServicesFailure = createAction('[App] load services failure');

export const loadSubpages = createAction('[App] load subpages');

export const loadSubpagesSuccess = createAction('[App] load subpages success', props<{
  subpages: SubpageAppEntitySubpageRead[]
}>());

export const loadSubpagesFailure = createAction('[App] load subpages failure');

export const loginGovPl = createAction(
  '[App] login gov pl',
  props<{
    samlart: string,
    successFnc: (v: TokenData | null) => void,
    failureFnc: (v: HttpErrorResponse) => void
  }>()
);

export const loginGovPlSuccess = createAction('[App] login gov pl success');

export const loginGovPlFailure = createAction(
  '[App] login gov pl failure'
);

export const setUISettings = createAction(
  '[App] set ui settings',
  props<{ uiSettings: UISettings | null }>()
);
